function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "bag",
  d: "M17.97,8.155H13.482V6.315a6.314,6.314,0,0,0-12.628,0V8.155H-4.006a.73.73,0,0,0-.728.728v19.48A3.639,3.639,0,0,0-1.1,32H15.067A3.638,3.638,0,0,0,18.7,28.363V8.883a.736.736,0,0,0-.734-.728ZM2.3,6.307a4.859,4.859,0,1,1,9.719,0V8.148H2.3ZM17.243,28.363a2.189,2.189,0,0,1-2.182,2.182H-1.1a2.188,2.188,0,0,1-2.182-2.182V9.61H.846v2.961a.727.727,0,1,0,1.455,0V9.61h9.726v2.961a.727.727,0,1,0,1.455,0V9.61h3.761Zm0,0",
  transform: "translate(4.734 0)",
  fill: "#191919"
});

var SvgCart20 = function SvgCart20(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.438,
    height: 32,
    viewBox: "0 0 23.438 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCart20, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cart-20.4bd84d23.svg";
export { ForwardRef as ReactComponent };